import { render, staticRenderFns } from "./PopupAddHotel.vue?vue&type=template&id=32f06ec2&scoped=true"
import script from "./PopupAddHotel.vue?vue&type=script&lang=js"
export * from "./PopupAddHotel.vue?vue&type=script&lang=js"
import style0 from "./PopupAddHotel.vue?vue&type=style&index=0&id=32f06ec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f06ec2",
  null
  
)

export default component.exports